<div class="max-w-full overflow-x-auto custom-scrollbar">
  <div id="chartEight" class="min-w-[1000px] 2xl:min-w-full">
    <apx-chart
      [series]="series"
      [chart]="chart"
      [colors]="colors"
      [stroke]="stroke"
      [fill]="fill"
      [markers]="markers"
      [grid]="grid"
      [dataLabels]="dataLabels"
      [tooltip]="tooltip"
      [xaxis]="xaxis"
      [yaxis]="yaxis"
      [legend]="legend"
    ></apx-chart>
  </div>
</div>
